function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import SvgIcon from "./SvgIcon";
const LeafLine = (props)=>{
    return /*#__PURE__*/ _jsxs(SvgIcon, _objectSpread({}, props, {
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ _jsx("path", {
                id: "Path_8793",
                "data-name": "Path 8793",
                d: "M0,0H24V24H0Z",
                fill: "none"
            }),
            /*#__PURE__*/ _jsx("path", {
                id: "Path_8794",
                "data-name": "Path 8794",
                d: "M21,3V5c0,9.627-5.373,14-12,14H5.243A17.056,17.056,0,0,0,5,22H3a18.719,18.719,0,0,1,.346-3.732A31.554,31.554,0,0,1,3,13,10,10,0,0,1,13,3C15,3,17,4,21,3ZM13,5a8,8,0,0,0-8,8q0,.543.01,1.046A15.079,15.079,0,0,1,10.5,9.132l.992,1.736C8.641,12.5,6.747,14.354,5.776,17H9c6.015,0,9.871-3.973,10-11.612a16.579,16.579,0,0,1-4.22-.188A10.873,10.873,0,0,0,13,5Z"
            })
        ]
    }));
};
export default /*#__PURE__*/ memo(LeafLine);
